<template>
  <div class="fit-content">
    <div>
      <DataTableDeCrud
        :items="leis"
        :headers="headers"
        :rotina-id="ID_TELA_DE_LEI"
        :configurar="false"
        :loading="loading"
        @create="() => abrirDialogCriarLei()"
        @update="(indice) => abrirDialogEditarLei(indice)"
        @delete="(indice) => openDialogDeleteLei(indice)"
      >
        <template #[`item.icms`]="{ item }">
          <v-icon v-if="item.icms" color="green">mdi-check</v-icon>
          <v-icon v-else color="red">mdi-close</v-icon>
        </template>

        <template #[`item.piscofins`]="{ item }">
          <v-icon v-if="item.piscofins" color="green">mdi-check</v-icon>
          <v-icon v-else color="red">mdi-close</v-icon>
        </template>
      </DataTableDeCrud>

      <DialogDeEdicaoDeLei
        :operacao="operacao"
        :show-dialog.sync="showDialogParam"
        :lei-param="leiParam"
        :itens="itensParam"
        @confirmado="atualizarLei"
      />
      <SnackbarMessage
        :show-snack.sync="snackbar.showSnackParam"
        :snack-text="snackbar.snackTextParam"
        :snack-type="snackbar.snackTypeParam"
      />

      <v-dialog v-model="dialogDeleteLei" persistent max-width="380">
        <v-card>
          <v-card-title class="headline">Excluir</v-card-title>
          <v-card-text refs="leiDelete">
            Tem certeza que deseja excluir a lei <b> {{ leiDelete.nome }} </b>?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialogDeleteLei = false">Cancelar</v-btn>
            <v-btn color="green darken-1" text @click="removerLei">Confirmar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import LeiService from '../../../services/lei/lei'
import SnackbarMessage from '../../../components/SnackbarMessage'
import DialogDeEdicaoDeLei from '../../../components/leis/DialogDeEdicaoDeLei'
import DataTableDeCrud from '../../../components/DataTableDeCrud'
import SnackBar from '../../../models/components/snackbar'
import Lei from '../../../models/lei'
import { ID_TELA_DE_LEI } from '@/common/constants'

export default {
  components: {
    SnackbarMessage,
    DataTableDeCrud,
    DialogDeEdicaoDeLei
  },
  data: () => ({
    name: 'TelaDeLei',
    headers: [
      { text: 'Código', value: 'codigo' },
      { text: 'Nome', value: 'nome' },
      { text: 'ICMS', value: 'icms' },
      { text: 'PIS / COFINS', value: 'piscofins' }
    ],
    leis: [],
    loading: false,
    validForm: false,
    dialog: false,
    operacao: '',
    showDialogParam: false,
    leiParam: new Lei(),
    itensParam: {},
    snackbar: new SnackBar(),
    dialogDeleteLei: false,
    leiDelete: new Lei(),
    indiceLeiDelete: 0,
    ID_TELA_DE_LEI: ID_TELA_DE_LEI
  }),

  created() {
    this.initialize()
  },

  methods: {
    initialize() {
      try {
        this.loadLeis()
      } catch (error) {
        this.snackbar.snackTextParam = 'Não foi possível encontrar leis cadastradas.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
    },

    async loadLeis() {
      this.loading = true
      const response = await LeiService.getAll()
      this.leis = response
      this.loading = false
    },

    atualizarLei(lei) {
      if (!lei) return

      const indice = this.leis.findIndex((leiExistente) => leiExistente.id === lei.id)

      if (indice === -1) {
        this.leis.push(lei)
        this.snackbar.snackTextParam = 'Lei criada com sucesso.'
      } else {
        this.leis.splice(indice, 1, lei)
        this.snackbar.snackTextParam = 'Lei atualizada com sucesso.'
      }

      this.snackbar.snackTypeParam = 'sucess'
      this.snackbar.showSnackParam = true
    },

    openDialogDeleteLei(indice) {
      this.leiDelete = this.leis[indice]
      if (!this.leiDelete.id) return

      this.indiceLeiDelete = indice
      this.dialogDeleteLei = true
    },

    async removerLei() {
      try {
        await LeiService.deleteById(this.leiDelete.id)
        this.snackbar.snackTextParam = 'Lei removida com sucesso.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
        this.leis.splice(this.indiceLeiDelete, 1)
      } catch (error) {
        this.snackbar.snackTextParam = `${error.response.status} | ${
          error.response.data.message === undefined ? error.message : error.response.data.message
        }`
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
      this.dialogDeleteLei = false
    },

    abrirDialogCriarLei() {
      this.operacao = 'adicionar'
      this.itensParam = {}
      this.leiParam = new Lei()
      this.showDialogParam = true
    },

    abrirDialogEditarLei(indice) {
      this.operacao = 'editar'
      this.itensParam = {}
      this.leiParam = { ...this.leis[indice] }
      this.showDialogParam = true
    }
  }
}
</script>
